export default __webpack_public_path__ + "static/apple-main-banner-cdd1f8e2a60553187845d58fe8980528.jpg";